import { createContext, memo, type ReactNode, useContext, useMemo } from 'react';

const PlanRevampTableContext = createContext(false);

export const usePlanRevampTable = () => useContext(PlanRevampTableContext);

interface ProviderProperties {
  children: ReactNode;
}

/** Active only inside org-chart table view (RevampDriverTableView). */
export const PlanRevampTableProvider = memo(({ children }: ProviderProperties) => {
  const value = useMemo(() => true, []);
  return (
    <PlanRevampTableContext.Provider value={value}>{children}</PlanRevampTableContext.Provider>
  );
});

PlanRevampTableProvider.displayName = 'PlanRevampTableProvider';
